import { render, staticRenderFns } from "./building_log.vue?vue&type=template&id=7653dc04"
import script from "./building_log.vue?vue&type=script&lang=js"
export * from "./building_log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports